export const OAUTH_REDIRECT = "OAUTH_REDIRECT"
export const SET_OAUTH_REDIRECT = "SET_OAUTH_REDIRECT"

export const callOAuthRedirect = () => ({ type: OAUTH_REDIRECT })
export const setOAuthRedirect = () => ({ type: SET_OAUTH_REDIRECT })
